import React from 'react';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import DropdownHeader from 'semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownHeader';
import DropdownItem from 'semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem';
import getMenuOptions from 'semantic-ui-react/dist/commonjs/modules/Dropdown/utils/getMenuOptions';
import '@purple/semantic-ui-purple-theme/components/dropdown.css';

import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';

const getKeyOrValue = (key, value) => (isNil(key) ? value : /* istanbul ignore next */key);

class GroupedDropdown extends Dropdown {
  renderOptions = () => {
    const { lazyLoad, multiple, search, noResultsMessage } = this.props;
    const { open, selectedIndex, value } = this.state;

    // lazy load, only render options when open
    if (lazyLoad && !open) return null;

    const options = getMenuOptions({
      value: this.state.value,
      options: this.props.options,
      searchQuery: this.state.searchQuery,

      additionLabel: this.props.additionLabel,
      additionPosition: this.props.additionPosition,
      allowAdditions: this.props.allowAdditions,
      deburr: this.props.deburr,
      multiple: this.props.multiple,
      search: this.props.search,
    });

    /* istanbul ignore next */
    if (noResultsMessage !== null && search && isEmpty(options)) {
      return <div className="message">{noResultsMessage}</div>;
    }

    const isActive = multiple ?
      (optValue) => includes(value, optValue) :
      /* istanbul ignore next */(optValue) => optValue === value;

    return options.reduce((acc, opt, i) => {
      if (opt.header) {
        const showHeader = !Object.keys(opt.values).every((key) => value.includes(key));

        if (showHeader) {
          acc.push(DropdownHeader.create(
            opt.header,
            { autoGenerateKey: true },
          ));
        }
      } else {
        acc.push(DropdownItem.create({
          active: isActive(opt.value),
          onClick: this.handleItemClick,
          selected: selectedIndex === i,
          ...opt,
          key: getKeyOrValue(opt.key, opt.value),
          // Needed for handling click events on disabled items
          style: { ...opt.style, pointerEvents: 'all' },
        }));
      }

      return acc;
    }, []);
  }
}

export default GroupedDropdown;
